import React, { useState } from "react";
import { ArrowRight, Star, Play } from "lucide-react";
import { hero } from "../mock";
import VideoModal from "./VideoModal";

// Diabetes video used as the hero header visual
const diabetesVideo = {
  title: "I\u2019m Stronger than Diabetes!",
  vimeoId: "1135833997",
};

const Hero = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="relative min-h-[86vh] flex items-center overflow-hidden pt-[76px] pb-20">
      {/* Diabetes trailer autoplaying background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/diabetes-trailer.mp4"
        poster="/hero-poster.jpg"
        autoPlay
        muted
        loop
        playsInline
      />
      {/* Brand blue overlay for readability */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(105deg, rgba(24,126,228,0.92) 0%, rgba(24,126,228,0.7) 40%, rgba(24,126,228,0.28) 75%, rgba(24,126,228,0.08) 100%)",
        }}
      />

      {/* Decorative stars */}
      <Star className="absolute top-28 left-[8%] w-8 h-8 text-white/40 brave-float" fill="currentColor" strokeWidth={0} />
      <Star className="absolute bottom-24 left-[22%] w-5 h-5 text-white/30 brave-float" style={{ animationDelay: "1.2s" }} fill="currentColor" strokeWidth={0} />
      <Star className="absolute top-1/3 left-[3%] w-4 h-4 text-[#F1C91F]/70 brave-float" style={{ animationDelay: "0.6s" }} fill="currentColor" strokeWidth={0} />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="font-display text-white text-4xl sm:text-5xl md:text-6xl lg:text-[72px] brave-shadow-text">
            {hero.title}
          </h1>
          <p className="mt-6 text-white text-lg md:text-xl font-semibold leading-relaxed max-w-xl">
            {hero.description}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              onClick={() => setShowVideo(true)}
              className="group inline-flex items-center gap-3 h-14 font-display text-white text-base md:text-lg pl-2 pr-6 rounded-full transition-transform duration-200 hover:scale-105 shadow-lg"
              style={{ backgroundColor: "#FF1228" }}
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white/20 group-hover:bg-white/30 transition-colors">
                <Play className="w-5 h-5 text-white ml-0.5" fill="white" strokeWidth={0} />
              </span>
              Watch the Video
            </button>
            <a
              href={hero.cta.href}
              className="inline-flex items-center gap-2 h-14 font-display text-white text-base md:text-lg px-7 rounded-full transition-transform duration-200 hover:scale-105 shadow-lg"
              style={{ backgroundColor: "#FF6C10" }}
            >
              {hero.cta.label}
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      {/* bottom wave */}
      <svg className="absolute bottom-0 left-0 w-full pointer-events-none z-0" viewBox="0 0 1440 90" preserveAspectRatio="none" style={{ height: 70 }}>
        <path fill="#ffffff" d="M0,64 C240,110 480,10 720,32 C960,54 1200,110 1440,58 L1440,90 L0,90 Z" />
      </svg>

      {showVideo && (
        <VideoModal video={diabetesVideo} onClose={() => setShowVideo(false)} />
      )}
    </section>
  );
};

export default Hero;
